import React from 'react';
import { motion } from 'framer-motion';
import { Heart } from 'lucide-react';
export function About() {
  return <section id="about" className="py-24 bg-white" data-id="element-10">
      <div className="max-w-7xl mx-auto px-6" data-id="element-11">
        <div className="grid md:grid-cols-2 gap-16 items-center" data-id="element-12">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="relative" data-id="element-13">
            <div className="absolute -inset-4 bg-hope-mustard/10 rounded-3xl transform -rotate-3" data-id="element-14"></div>
            <img src="https://cdn.magicpatterns.com/uploads/bqZFDXeupbrCNm2JN4WfWn/IMG_9572.jpg" alt="HOPE Cafetería Patio" className="relative rounded-2xl shadow-xl w-full object-cover aspect-[4/3]" data-id="element-15" />
            <div className="absolute -bottom-6 -right-6 bg-hope-teal text-white p-6 rounded-2xl shadow-lg max-w-[200px]" data-id="element-16">
              <Heart className="w-8 h-8 mb-3 text-hope-mustard" data-id="element-17" />
              <p className="font-serif font-medium text-lg leading-tight" data-id="element-18">
                Serving the community since day one.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-19">
            <h2 className="text-4xl md:text-5xl font-serif font-bold text-hope-brown mb-6" data-id="element-20">
              More than just a café.
            </h2>
            <div className="space-y-6 text-lg text-hope-brown/80 leading-relaxed" data-id="element-21">
              <p data-id="element-22">
                HOPE Cafetería lives inside the heart of{' '}
                <strong className="text-hope-terracotta font-medium" data-id="element-23">
                  Centro Comunitario Palabras de Esperanza
                </strong>
                . We believe that a great cup of coffee can do more than just
                wake you up—it can change lives.
              </p>
              <p data-id="element-24">
                Every purchase you make directly funds our community programs,
                supporting youth development, family outreach, and educational
                initiatives here in Puerto Peñasco.
              </p>
              <p data-id="element-25">
                Whether you're grabbing a quick espresso, settling in to work on
                our sunny patio, or picking up some local merch, you are part of
                our mission to bring hope and opportunity to our neighborhood.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}